// eslint-disable-next-line import/prefer-default-export
export function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  return value.format(format);
}
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/date-picker/utils.js
// module id = 321
// module chunks = 0